import { handleActions } from 'redux-actions';
import { MESSAGE_SHOW } from '../actions/MessagesActions';

const initialState = {
  taskId: 0,
  op: '',
  parameters: {},
  txt: '',
};

export const MessagesReducer = handleActions({
  [MESSAGE_SHOW]: (state, action) => ({
    ...state,
    taskId: action.payload.taskId,
    op: action.payload.op,
    parameters: action.payload.parameters,
    txt: action.payload.txt,
  }),
}, initialState);
